import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resizeParent } from '../../services/Utils'

// Actions
import { configure } from '../../actions/Settings'
import { getRSSFeed } from '../../actions/rssreader'

// Components
import Spinner from '../Spinner';
import RSSCard from './RSSCard';
import RSSTwentySeventeenCard from './RSSTwentySeventeenCard';

// Styles
import styles from './TCCRSSReader.css';

// Class
class TCCRSSReader extends Component {

    constructor(props){

        super(props);

        let cardClassName = 'column-four';
        if(props.limit === "2") cardClassName = 'column-six';
        if(props.limit === "1") cardClassName = 'column-twelve';

        this.state = {
            page: 1,
            loaded: false,
            className: styles.loading,
            cardClassName: cardClassName
        }
    }

    getFeed(){

        let args = {
            feed: this.props.feed,
            limit: this.props.limit
        }

        this.props.getRSSFeed(args)

    }

    componentDidMount(){

        this.props.configure(this.props.site);
        this.getFeed();
        setTimeout(() =>{

            this.setState({
                loaded: true,
                className: styles.TCCRSSReader
            })
        },1000);

    }

    componentDidUpdate(){
        resizeParent();
    }

    renderCards(){

        let cardClassName = 'column-four';
        if(this.props.limit === "2" || this.props.rss.data.items.length === 2) cardClassName = 'column-six';
        if(this.props.limit === "1" || this.props.rss.data.items.length === 1) cardClassName = 'column-twelve';
    

        if(!this.props.rss.data.items) return;       
        return this.props.rss.data.items.map((item,index) => {

            let openInModal = false;

            // Check For Youtube
            if(item.link.indexOf('youtube') > -1) { cardClassName += ' youtube'; openInModal = true; }
            if(item.link.indexOf('vimeo') > -1) { cardClassName += ' vimeo'; openInModal = true; }

            // Render Card
            if(this.props.theme == '2017') return (<RSSTwentySeventeenCard {...item} key={index} modal={openInModal} />);
            return (<RSSCard {...item} key={index} className={cardClassName} modal={openInModal} />)
        })

    }

    render() {

        // Guard: Not loaded
        if(!this.props.rss.data) return (<div className={this.state.className}><Spinner /></div>);


        return (
            <div className={this.state.className}>

                {this.renderCards()}
                
            </div>
        );

    }
}

const mapStateToProps = state => ({
    rss: state.RSSReader,
    settings: state.Settings
})

const mapDispatchToProps = dispatch => ({
    configure: (site) => dispatch(configure(site)),
    getRSSFeed: (args) => dispatch(getRSSFeed(args))
})

export default connect(mapStateToProps, mapDispatchToProps)(TCCRSSReader);
